import { createSlice } from '@reduxjs/toolkit';
import { submitTryout } from './Utils/TryoutUtils';

const initialState = {
    title: '',
    description: '',
    time: '',
    start_at: '',
    end_at: '',
    quotas: '',
    banner: '',
    category: '',
    is_toefl: '',
    toefl_setup: [{
        name: '',
        instructions: '',
        total_questions: '',
        duration: '',
        break: '',
    }],
    is_tryout_used: false,
    is_have_questions: false,
    is_quiz: '',
    is_live: '',
    is_report_show: '',
    instruction: '',
    ads_video: '',
    tutorial_video: '',
    locked_type: 'none',
    locked_until_at: '',
    locked_message: '',
    isUpdate: false,
    id: '',
    isLoading: false,
};

const addTryout = createSlice(
    {
        name: 'addTryout',
        initialState: initialState,
        reducers: {
            setField: (state, action) => {
                const { field, value } = action.payload;
                state[field] = value;
            },
            resetState: (state) => {
                return initialState;
            },
        },
        extraReducers: (builder) => {
            builder
                .addCase(submitTryout.pending, (state) => {
                    // Handle loading state
                    state.isLoading = true;
                })
                .addCase(submitTryout.fulfilled, (state, action) => {
                    // Handle success state
                    state.isLoading = false;
                    // console.log('Sukses:', action.payload);
                })
                .addCase(submitTryout.rejected, (state, action) => {
                    console.log(action.error.message, "error action")
                    state.isLoading = false;
                });
        }
    }
);


export const { setField, resetState } = addTryout.actions;

export default addTryout.reducer;